import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { authService } from '../services/auth';
import { AuthContextType } from '../types/auth';

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(authService.isAuthenticated());

  // Sayfa yüklendiğinde kullanıcı bilgilerini kontrol et ve güncelle
  useEffect(() => {
    const refreshUserDataOnLoad = async () => {
      if (authService.isAuthenticated()) {
        try {
          // LocalStorage'dan mevcut kullanıcı bilgilerini al
          const userInfoStr = localStorage.getItem('userInfo');
          if (userInfoStr) {
            const userInfo = JSON.parse(userInfoStr);
            if (userInfo.id) {
              // Kullanıcı bilgilerini veritabanından yenile
              await authService.refreshUserInfo(userInfo.id);
              console.log('Kullanıcı bilgileri sayfa yükleme sırasında güncellendi');
            }
          }
        } catch (error) {
          console.error('Kullanıcı bilgileri güncellenirken hata:', error);
          // API hatası alındığında bile localStorage'i güncellemek için
          // mevcut localStorage verilerini tutmaya devam et
          // Kullanıcı oturumunu sonlandırmaya gerek yok
        }
      }
    };

    refreshUserDataOnLoad();
  }, []); // Sadece component mount olduğunda çalış

  // Browser tab'ına geri dönüldüğünde kullanıcı bilgilerini kontrol et
  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (!document.hidden && authService.isAuthenticated()) {
        try {
          const userInfoStr = localStorage.getItem('userInfo');
          if (userInfoStr) {
            const userInfo = JSON.parse(userInfoStr);
            if (userInfo.id) {
              await authService.refreshUserInfo(userInfo.id);
              console.log('Kullanıcı bilgileri tab odaklanmasında güncellendi');
            }
          }
        } catch (error) {
          console.error('Tab odaklanmasında kullanıcı bilgileri güncellenirken hata:', error);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  // Eğer localStorage'da token değişirse otomatik güncelle
  useEffect(() => {
    const handleStorage = () => {
      setIsAuthenticated(authService.isAuthenticated());
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
